/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Culture_PlaceholderInputs */

const en_company_profile_culture_placeholder = /** @type {(inputs: Company_Profile_Culture_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description of company culture, mission statements and values...`)
};

const de_company_profile_culture_placeholder = /** @type {(inputs: Company_Profile_Culture_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung der Unternehmenskultur, Leitbilder und Werte...`)
};

/**
* | output |
* | --- |
* | "Description of company culture, mission statements and values..." |
*
* @param {Company_Profile_Culture_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_culture_placeholder = /** @type {((inputs?: Company_Profile_Culture_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Culture_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_culture_placeholder(inputs)
	return en_company_profile_culture_placeholder(inputs)
});